export const patterns = [
  { key: "NONE", display: "No Action" },
  { key: "CLAIM_AND_COMPOUND", display: "Claim & Compound" },
  { key: "CLAIM_AND_SELL", display: "Claim & Sell" },
];
